import { ApplierOption } from '~/apps/smartsend/lib/helpers/ApplierOption';
import { Customer, Dimensions, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
export const DefaultExcludedServiceTags = ['SmartSendExclude'];
export const FavouriteIncludeServiceTags = ['SmartSendFavourite'];

export type CurrentSelectionItemType = {
  ItemId?: string;
  Dimensions?: Dimensions;
  Value?: number;
  RecipientCountry?: {
    IsoCode: string;
    Subdivision?: string;
    Postcode?: string;
  };
  SenderCountry?: {
    IsoCode: string;
    Subdivision?: string;
    Postcode?: string;
  };
  Service?: {
    Id: string;
  };
  Tags?: string[];
  Products?: { Id: string; Quantity: number; SourceId: string; Description: string; TariffCode: string | undefined }[];
  Extras?: string[];
};

export const ToSmartSendAnalyticsModel = (item: SmartSendItemApiModel): CurrentSelectionItemType => ({
  ItemId: item.Id,
  Dimensions: item.PackageDimensions
    ? {
        Length: item.PackageDimensions?.Length,
        Width: item.PackageDimensions?.Width,
        Height: item.PackageDimensions?.Height,
        Weight: item.PackageDimensions?.Weight
      }
    : undefined,
  Value: item.Value,
  RecipientCountry: {
    IsoCode: item.Recipient.CountryIsoCode,
    Subdivision: item.Recipient.CountrySubdivision
  },
  SenderCountry: {
    IsoCode: item.Sender.CountryIsoCode,
    Subdivision: item.Sender.CountrySubdivision
  },
  Service: {
    Id: item.Service?.Id
  },
  Tags: item.Tags,
  Products:
    item.MarketplaceOrderLines?.map((x) => ({
      Id: x.Id,
      Quantity: x.Quantity,
      SourceId: x.Source.Id,
      Description: x.Product.Description,
      TariffCode: x.Product.TariffCode || undefined,
      Sku: x.Product.Sku || undefined,
      CountryOfManufacture: x.Product.CountryOfManufacture || undefined
    })) ?? [],
  Extras: item.Extras?.map((x) => x.Id) ?? []
});

export const ToSmartSendAnalyticsPatchModel = (
  item: CurrentSelectionItemType,
  actions: ApplierOption[]
): CurrentSelectionItemType => {
  const output: CurrentSelectionItemType = {};

  if (actions.includes('Dimensions') && item.Dimensions) {
    output.Dimensions = item.Dimensions;
  }

  if (actions.includes('ItemValue')) {
    output.Value = item.Value;
  }

  if (actions.includes('Recipient') && item.RecipientCountry) {
    output.RecipientCountry = item.RecipientCountry;
  }

  if (actions.includes('Sender') && item.SenderCountry) {
    output.SenderCountry = item.SenderCountry;
  }

  if (actions.includes('Service') && item.Service) {
    output.Service = item.Service;
  }

  if (actions.includes('Tags') && item.Tags) {
    output.Tags = item.Tags;
  }

  if (actions.includes('MarketplaceOrderLines') && item.Products) {
    output.Products = item.Products;
  }

  if (actions.includes('Extras') && item.Extras) {
    output.Extras = item.Extras;
  }

  return output;
};

export type CurrentSelectionType = {
  limitToAccount: boolean;
  accountId: string;
  id: string;
  items: CurrentSelectionItemType[];
  provider: string;
  extras: string[];
  marketplaceService: string;
  sender: Customer;
  recipient: Customer;
};

export type DefaultQuoteRequestType = {
  provider: string;
  accountId: string;
  includeTags: string[];
  excludeTags: string[];
  sender: Customer;
  recipient: Customer;
};
